module.exports = __webpack_public_path__ + "static/2_web_ui_ux-cdb9a80cdfda0e859efaa6aba3ba0900.webp";